/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import stats from '../../http/requests/stats';
import router from '@/router';

export default {
  load({ commit }) {
    return new Promise((resolve, reject) => {
      stats
        .loadData()
        .then(response => {
          commit('SET_STATS_DATA', response.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        });
    });
  }
};
